import { render, staticRenderFns } from "./CrmSummaryShortcutCard.vue?vue&type=template&id=673101a8&scoped=true&"
import script from "./CrmSummaryShortcutCard.vue?vue&type=script&lang=js&"
export * from "./CrmSummaryShortcutCard.vue?vue&type=script&lang=js&"
import style0 from "./CrmSummaryShortcutCard.vue?vue&type=style&index=0&id=673101a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673101a8",
  null
  
)

export default component.exports